export enum EquityTypeEnum {
  Equity = 'Equity',
  PreferredEquity = 'PreferredEquity',
}
